import React from 'react'
import Navbar from './../../components/Navbar';
import IndustriesImageContainer from './../../components/IndustriesImageContainer';
import Footer from '../../components/Footer';
import ashoka from "../../assets/images/contents/case-study-ashoka.png"
import filter_color from "../../assets/images/design/colorFilter.svg"
import CaseStudyForm from './CaseStudyForm';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectLanguage } from '../../redux/language/selector';

const CaseStudyAshoka = () => {
  const {t} = useTranslation()

  const language = useSelector(selectLanguage)

  return (
    <div className='ashoka bg-primary'>
      <div className='color-filter-left' style={{ top: "35%" }} >
        <img src={filter_color} alt="" className='img-responsive' />
      </div>
      <Navbar />
      <div className='ashoka-content container pt-150'>
        <div className='row'>
          <div className="col-lg-w--500">
            {language === "en"
            ?
            <p className='text-white font-40 font-weight-medium pr-lg-150'>Download Ashoka University <span className='text-gradient'>Case Study</span></p>
            :
            <p className='text-white font-40 font-weight-medium pr-lg-50'>Tải xuống <span className='text-gradient'>nghiên cứu điển hình</span> của Đại học Ashoka</p>
            }
            <div className="ashoka-card mt-40">
              <div className='ashoka-card_image'>
                <img src={ashoka} alt="" className='img-responsive' />
              </div>
            </div>

            <div className='col-xs-12 ashoka-card-info mt-40'>
              <div className="col-xl-3 col-xs-12 ashoka-card-info_item">
                <p className='font-18 text-white'>{t('ashoka.client')}</p>
                <p className='text-gray font-14'>{t('ashoka.ashoka-university')}</p>
              </div>
              <div className="col-xl-3 col-xs-12 ashoka-card-info_item">
                <p className='font-18 text-white'>{t('ashoka.category')}</p>
                <p className='text-gray font-14'>{t('ashoka.education')}</p>
              </div>
              <div className="col-xl-3 col-xs-12 ashoka-card-info_item">
                <p className='font-18 text-white'>{t('ashoka.date')}</p>
                <p className='text-gray font-14'>_</p>
              </div>
              <div className="col-xl-3 col-xs-12 ashoka-card-info_item">
                <p className='font-18 text-white'>{t('ashoka.status')}</p>
                <p className='text-gray font-14'>_</p>
              </div>
            </div>

            <div className='col-xs-12'>
              <div className='row'>
                <p className='text-white font-40 pt-40 font-weight-medium'>{t('ashoka.title-1')}</p>
                <p className='text-gradient font-40 font-weight-medium'>{t('ashoka.title-2')}</p>
                <p className='text-gray pt-20'>{t('ashoka.content')}</p>
              </div>

            </div>
          </div>
          <div className="col-xs-12 col-lg-w-500 sticky-form">
            <p className='text-white font-20 font-weight-medium pt-lg-0 pt-50'>{t('ashoka.title-3')}</p>
            <CaseStudyForm/>
          </div>
        </div>
      </div>
      <div className='container'>
        <IndustriesImageContainer />
      </div>
      <Footer />
    </div>
  )
}

export default CaseStudyAshoka